export const getComments = (state) => state.comments;
export const getIsFetchingComments = (state) => state.isFetchingComments;
export const getIsFetchingComment = (state) => state.isFetchingComment;
export const getTargetCommentId = (state) => state.targetCommentId;
